import eventBus from "../../../../../util/eventBus"
import React from 'react'
import ReactDOM from 'react-dom'

import MySub from "./mySub"

import ExpCompany from "./views/app.jsx";

import "@kdcloudjs/kdesign/dist/kdesign.css";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model

            this.I18N = key => KDApi.getLangMsg(model, key)

            this.mySub = new MySub(model, eventBus)
        },
        init: function (props) {
            console.log('-----init', props)

            setHtml(this.model, props, {
                mySub: this.mySub, I18N: this.I18N
            })
        },
        update: function (props) {
            console.log('-----update', props)

            this.mySub.pub(props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)

            this.mySub.unsub()

            ReactDOM.unmountComponentAtNode(this.model.dom)
        }
    }

    const setHtml = function (model, primaryProps, custUtils) {
        const { mySub, I18N } = custUtils

        KDApi.loadFile('./css/index.css', model, () => {

            function Root(props) {
                console.log("Root");

                const { customProps, model } = props

                const { data: { data } } = customProps

                return <ExpCompany I18N={I18N} data={data}  />
            }

            ReactDOM.render(<Root model={model} customProps={primaryProps} />, model.dom)

        })
    }

    // 注册自定义组件
    KDApi.register('kdCompanyExp', MyComponent, { isMulLang: true })
})(window.KDApi)
